// Core
import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

export interface DataTableViewportProps {
  maxHeight?: React.CSSProperties['maxHeight'];
  height?: React.CSSProperties['height'];
  children?: React.ReactNode;
}

export const DataTableViewport = styled(
  forwardRef(
    (
      { children, ...restProps }: DataTableViewportProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      return (
        <div ref={ref} {...restProps}>
          {children}
        </div>
      );
    }
  )
).withConfig({
  displayName: 'DataTableViewport',
})<DataTableViewportProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 13rem;
  overflow: auto;
  ${({ maxHeight }) => (maxHeight ? `max-height: ${maxHeight};` : '')}
  ${({ height }) => (height ? `height: ${height};` : '')}
`;
